import { render, staticRenderFns } from "./Pill.vue?vue&type=template&id=19a39390&scoped=true"
import script from "./Pill.vue?vue&type=script&setup=true&lang=js"
export * from "./Pill.vue?vue&type=script&setup=true&lang=js"
import style0 from "./Pill.vue?vue&type=style&index=0&id=19a39390&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19a39390",
  null
  
)

export default component.exports